<template>
  <div>
    <h1>
      Contrato <span v-if="this.id > 0">#{{ id }}</span>
    </h1>
    <v-container grid-list-md>
      <v-toolbar color="transparent" flat dense>
        <v-toolbar-items>
          <v-btn to="/contracts" text>
            <v-icon>view_list</v-icon>
          </v-btn>
        </v-toolbar-items>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" text> <v-icon>list_alt</v-icon>Relatórios</v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(item, i) in reports"
                :key="i"
                :disabled="!item.available()"
                @click="showReport(i)"
              >
                <v-list-item-title>
                  {{ item.title }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <v-btn text color="error" disabled>Excluir</v-btn> -->
          <v-btn text @click="saveContract">Salvar</v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-layout column>
        <v-flex md12 mt-3>
          <v-tabs
            centered
            background-color="primary"
            dark
            slider-color="primary"
          >
            <v-tabs-slider></v-tabs-slider>
            <v-tab ripple>Dados</v-tab>
            <v-tab>Pagamentos</v-tab>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <v-card>
                    <v-layout mx-4 pt-4 wrap>
                      <v-flex md12>
                        <Combobox
                          label="Excursão"
                          searchEndpoint="/trips/groupTrips"
                          item-text="name"
                          item-value="id"
                          v-model="contract.tripId"
                          @change="tripChanged"
                        ></Combobox>
                      </v-flex>
                      <v-flex md6>
                        <Combobox
                          label="Emissor"
                          searchEndpoint="/users"
                          item-text="name"
                          item-value="id"
                          v-model="contract.createdByUserId"
                        ></Combobox>
                      </v-flex>
                      <v-flex md6>
                        <Combobox
                          label="Responsável"
                          searchEndpoint="/users"
                          item-text="name"
                          item-value="id"
                          v-model="contract.responsibleUserId"
                        ></Combobox>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex md12 mt-3>
                  <v-card>
                    <v-card-title primary-title>Contratante</v-card-title>
                    <v-layout mx-4 pt-4 wrap>
                      <v-flex md12>
                        <v-text-field
                          name="contractingPartyName"
                          label="Nome"
                          id="contractingPartyName"
                          v-model="contract.contractingPartyName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          name="contractingPartyTaxId"
                          label="CPF"
                          id="contractingPartyTaxId"
                          v-model="contract.contractingPartyTaxId"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md3>
                        <v-text-field
                          name="contractingPartyNationalId"
                          label="RG"
                          id="contractingPartyNationalId"
                          v-model="contract.contractingPartyNationalId"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          name="contractingPartyProfession"
                          label="Profissão"
                          id="contractingPartyProfession"
                          v-model="contract.contractingPartyProfession"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          name="contractingPartyPhone"
                          label="Telefone"
                          id="contractingPartyPhone"
                          v-model="contract.contractingPartyPhone"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md6>
                        <v-text-field
                          name="contractingPartyEmail"
                          label="Email"
                          id="contractingPartyEmail"
                          v-model="contract.contractingPartyEmail"
                        ></v-text-field>
                      </v-flex>
                      <v-flex md12>
                        <v-text-field
                          name="contractingPartyAddress"
                          label="Endereço"
                          id="contractingPartyAddress"
                          v-model="contract.contractingPartyAddress"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
                <v-flex md12 mt-3>
                  <v-card>
                    <v-toolbar color="transparent" flat>
                      <v-toolbar-title>Passageiros</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon @click="this.showNewPassengerForm">
                        <v-icon>add</v-icon>
                      </v-btn>
                    </v-toolbar>
                    <v-layout px-4 wrap>
                      <v-flex md12>
                        <v-list two-line>
                          <template v-for="(item, i) in passengers">
                            <v-divider
                              v-if="i > 0"
                              :key="`divider_${item.customerId}`"
                            ></v-divider>
                            <v-list-item
                              ripple
                              :key="`tile_${item.customerId}`"
                              @click="editPassenger(item)"
                              :input-value="item.status != 2"
                              :color="
                                item.status < 2
                                  ? 'warning'
                                  : item.status > 2
                                  ? 'error'
                                  : ''
                              "
                            >
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  item.customerName
                                }}</v-list-item-title>
                                <v-list-item-subtitle chips>
                                  <v-chip-group column>
                                    <v-chip color="primary" text-color="white">
                                      {{ item.packageName }}
                                    </v-chip>

                                    <v-chip color="teal" text-color="white">
                                      <v-avatar left class="teal lighten-4">{{
                                        item.addOns.length
                                      }}</v-avatar
                                      >Opcionais
                                    </v-chip>
                                  </v-chip-group>
                                </v-list-item-subtitle>
                              </v-list-item-content>
                            </v-list-item>
                          </template>
                        </v-list>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item>
              <v-layout column>
                <v-flex md12 mt-3>
                  <v-card>
                    <v-layout mx-4 pt-4 wrap>
                      <v-flex md2>
                        <v-text-field
                          name="contractCost"
                          label="Valor"
                          id="contractCost"
                          :value="(contractCost / 1) | money"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex md2>
                        <v-text-field
                          name="contractTaxes"
                          label="Taxas"
                          id="contractTaxes"
                          :value="(contractTaxes / 1) | money"
                          prepend-icon="add"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex md2>
                        <MoneyInput
                          name="contractDiscount"
                          label="Desconto"
                          id="contractDiscount"
                          v-model="contract.totalDiscount"
                          prepend-icon="remove"
                        ></MoneyInput>
                      </v-flex>
                      <v-flex md2>
                        <MoneyInput
                          name="contractFine"
                          label="Multa"
                          id="contractFine"
                          v-model="contract.totalFine"
                          prepend-icon="add"
                        ></MoneyInput>
                      </v-flex>
                      <v-flex md2>
                        <v-text-field
                          name="contractTotalCost"
                          label="Total"
                          id="contractTotalCost"
                          prepend-icon="drag_handle"
                          :value="(contractTotalCost / 1) | money"
                          readonly
                        ></v-text-field>
                      </v-flex>
                      <v-flex md2>
                        <v-btn
                          @click="$refs.paymentManager.showPaymentForm()"
                          color="success"
                          ><v-icon>attach_money</v-icon> PAGAR</v-btn
                        >
                      </v-flex>
                      <v-flex md12>
                        <PaymentManagement
                          ref="paymentManager"
                          :contract-id="id"
                          :totalCost="contractTotalCost"
                          @selectedPayments="onSelectedPayments"
                          @selectedPaymentObject="onSelectedPaymentObject"
                        />
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>
          </v-tabs>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="isPassengerFormVisible" persistent max-width="800px">
      <v-card>
        <v-card-title class="title">Passageiro</v-card-title>
        <v-container grid-list-xs>
          <v-layout wrap>
            <v-flex md9>
              <Combobox
                label="Passageiro"
                searchEndpoint="/customers"
                item-text="name"
                item-value="id"
                v-model="passengerFormModel.passenger.customerId"
                @change="passengerCustomerPickerChanged"
              ></Combobox>
            </v-flex>
            <v-flex md3>
              <v-select
                name="status"
                :items="availablePassengerStatuses"
                v-model="passengerFormModel.passenger.status"
                label="Situação"
                id="status"
                item-text="text"
                item-value="code"
              ></v-select>
            </v-flex>
            <v-flex md6>
              <v-select
                :items="availablePackages"
                v-model="passengerFormModel.passenger.packageId"
                item-text="name"
                item-value="id"
                label="Pacote"
                @change="passengerPackagePickerChanged"
              ></v-select>
            </v-flex>
            <v-flex md3>
              <MoneyInput
                name="packagePrice"
                label="Preço do Pacote"
                id="packagePrice"
                v-model="passengerFormModel.passenger.packagePrice"
              ></MoneyInput>
            </v-flex>
            <v-flex md3>
              <MoneyInput
                name="boardingTax"
                label="Taxa de Embarque"
                id="boardingTax"
                v-model="passengerFormModel.passenger.boardingTax"
              ></MoneyInput>
            </v-flex>
            <v-flex md6>
              <v-text-field
                name="eticket"
                label="E-Ticket"
                id="eticket"
                v-model="passengerFormModel.passenger.eTicket"
              ></v-text-field>
            </v-flex>
            <v-flex md6>
              <v-text-field
                name="reservationNumber"
                label="Localizador"
                id="reservationNumber"
                v-model="passengerFormModel.passenger.reservationNumber"
              ></v-text-field>
            </v-flex>
            <v-flex md12>
              <v-text-field
                name="tag"
                label="Tag"
                id="tag"
                v-model="passengerFormModel.passenger.tag"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex md12>
              <v-card>
                <v-tabs
                  background-color="primary"
                  centered
                  dark
                  slider-color="primary"
                >
                  <v-tabs-slider></v-tabs-slider>
                  <v-tab ripple>Opcionais</v-tab>
                  <v-tab ripple>Documentos</v-tab>
                  <v-tab-item>
                    <v-list two-line>
                      <template
                        v-for="(addOn, i) in passengerFormModel.passenger
                          .addOns"
                      >
                        <v-divider
                          v-if="i > 0"
                          :key="`divider_addOn_${addOn.addOnId}`"
                        ></v-divider>
                        <v-list-item :key="`tile_addOn_${addOn.addOnId}`">
                          <v-list-item-content>
                            <v-list-item-title>{{
                              addOn.addOnName
                            }}</v-list-item-title>
                            <v-list-item-subtitle>
                              <MoneyInput
                                name="addOnPrice"
                                id="addOnPrice"
                                v-model="addOn.addOnPrice"
                              ></MoneyInput>
                            </v-list-item-subtitle>
                          </v-list-item-content>
                          <v-list-item-action>
                            <v-btn
                              text
                              icon
                              @click="removePassengerAddOn(addOn)"
                            >
                              <v-icon>delete</v-icon>
                            </v-btn>
                          </v-list-item-action>
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-tab-item>
                  <v-tab-item>
                    <v-expansion-panels>
                      <v-expansion-panel
                        v-for="documentCheck in passengerFormModel.passenger
                          .documentChecks"
                        :key="
                          `panel_documentCheck_${documentCheck.documentCheckId}`
                        "
                      >
                        <v-expansion-panel-header>
                          <span>
                            <v-icon color="red" v-if="documentCheck.status == 1"
                              >close</v-icon
                            >
                            <v-icon
                              color="green"
                              v-else-if="documentCheck.status == 2"
                              >done</v-icon
                            >
                            <v-icon color="amber" v-else>done</v-icon>
                            {{ documentCheck.documentCheckName }}
                          </span>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <v-alert type="info" :value="true">
                            {{ documentCheck.documentCheckDescription }}
                          </v-alert>
                          <v-card>
                            <v-card-text class="grey lighten-4">
                              <v-layout mx-3 wrap>
                                <v-flex md12></v-flex>
                                <v-flex md12>
                                  <v-select
                                    name="documentCheck_status"
                                    :items="availableDocumentCheckStatuses"
                                    v-model="documentCheck.status"
                                    label="Situação"
                                    id="documentCheck_status"
                                    item-text="text"
                                    item-value="code"
                                  ></v-select>
                                </v-flex>
                                <v-flex md12>
                                  <v-text-field
                                    name="`documentCheck_notes`"
                                    label="Observações"
                                    id="documentCheck_notes"
                                    v-model="documentCheck.notes"
                                  ></v-text-field>
                                </v-flex>
                              </v-layout>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                  </v-tab-item>
                </v-tabs>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions>
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn text v-on="on"> <v-icon>add</v-icon>Opcionais </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(addOn, index) in availableAddOns"
                :key="`addOn_${index}`"
                :disabled="doesPassengerHaveAddOn(addOn)"
                @click="ensureAddOnForPassenger(addOn)"
              >
                <v-list-item-title>
                  {{ addOn.name }} -
                  {{ addOn.price | money }}
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <v-btn
            v-if="passengerFormModel.passenger.customerId > 0"
            text
            @click="showVoucher(passengerFormModel.passenger)"
            ><v-icon>local_play</v-icon>Voucher</v-btn
          >
          <v-btn
            text
            v-if="passengerFormModel.passenger.customerId > 0"
            @click="showDocumentList(passengerFormModel.passenger)"
            ><v-icon>list</v-icon>Documentos</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn text @click="isPassengerFormVisible = false">Cancelar</v-btn>
          <v-btn color="primary" text @click="savePassenger">Salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <OperationStatusCard
      id="loadingStatusCard"
      ref="loadingStatusCard"
      progressMessage="Carregando"
      successMessage="Pronto"
      errorMessage="Falha ao carregar"
      v-model="contract.tripId"
    />
    <OperationStatusCard
      ref="operationStatusCard"
      progressMessage="Salvando"
      successMessage="Salvo com sucesso"
      errorMessage="Falha ao salvar"
    />
    <v-dialog :value="reportDialog" persistent max-width="80%">
      <v-card>
        <v-card-title class="headline">{{ this.reportTitle }}</v-card-title>
        <v-card-text>
          <iframe
            width="100%"
            height="500px"
            :src="this.reportUrl"
            frameborder="0"
          ></iframe>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="closeReport">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import api from "@/api";
import Combobox from "@/components/Shared/Combobox";
import MoneyInput from "@/components/Shared/MoneyInput";
import OperationStatusCard from "@/components/Shared/OperationStatusCard";
import PaymentManagement from "@/components/Contract/PaymentManagement";
export default {
  name: "contract-form",
  components: {
    Combobox,
    MoneyInput,
    OperationStatusCard,
    PaymentManagement
  },
  data: function() {
    return {
      reportTitle: null,
      reportDialog: false,
      reportUrl: null,
      reports: [
        {
          title: "Contrato",
          url: `/reports/contracts/${this.$route.params.id}`,
          available: () => true,
          qs: () => ""
        },
        {
          title: "Autorização de Cobrança",
          url: `/reports/contracts/${this.$route.params.id}/chargeAuthorization`,
          available: () => true,
          qs: () => ""
        },
        {
          title: "Recibo",
          url: `/reports/contracts/${this.$route.params.id}/paymentReceipt`,
          available: () =>
            this.selectedPaymentObject != 1 &&
            this.selectedPayments &&
            this.selectedPayments.length > 0,
          qs: () =>
            this.selectedPayments && this.selectedPayments.length > 0
              ? `payments=${this.selectedPayments.join("&payments=")}`
              : ""
        },
        {
          title: "Recibo de Opcionais",
          url: `/reports/contracts/${this.$route.params.id}/addOnsReceipt`,
          available: () =>
            this.selectedPaymentObject == 1 &&
            this.selectedPayments &&
            this.selectedPayments.length > 0,
          qs: () =>
            this.selectedPayments && this.selectedPayments.length > 0
              ? `payments=${this.selectedPayments.join("&payments=")}`
              : ""
        }
      ],
      contract: {
        totalDiscount: 0,
        totalFine: 0
      },
      groupTrip: {
        flightCosts: 0
      },
      passengers: [],
      availablePackages: [],
      availableAddOns: [],
      documentChecks: [],
      availableDocumentCheckStatuses: [
        { code: 1, text: "Pendente" },
        { code: 2, text: "Recebido" },
        { code: 3, text: "Dispensado" }
      ],
      availablePassengerStatuses: [
        { code: 1, text: "Reservado" },
        { code: 2, text: "Confirmado" },
        { code: 3, text: "Cancelado" },
        { code: 4, text: "Expirado" }
      ],
      isPassengerFormVisible: false,
      passengerFormModel: {
        currentCustomerId: null,
        passenger: {
          packagePrice: 0,
          boardingTax: 0,
          addOns: [],
          documentChecks: []
        }
      },
      selectedPayments: [],
      selectedPaymentObject: null
    };
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
    contractCost() {
      return [0]
        .concat(
          this.passengers
            .filter(p => p.status <= 2)
            .map(
              p =>
                this.groupTrip.flightCosts +
                p.packagePrice +
                [0]
                  .concat(p.addOns.map(a => a.addOnPrice))
                  .reduce((acc, curr) => acc + curr)
            )
        )
        .reduce((acc, curr) => acc + curr)
        .toFixed(2);
    },
    contractTaxes() {
      return [0]
        .concat(this.passengers.map(p => p.boardingTax))
        .reduce((acc, curr) => acc + curr)
        .toFixed(2);
    },
    contractTotalCost() {
      return (
        Number(this.contractCost) +
        Number(this.contractTaxes) -
        Number(this.contract.totalDiscount) +
        Number(this.contract.totalFine)
      ).toFixed(2);
    }
  },
  methods: {
    tripChanged(trip) {
      api.request("GET", `/trips/groupTrips/${trip.id}`).then(response => {
        this.groupTrip = response.data.groupTrip;
      });
      api.request("GET", `/trips/${trip.id}/package`).then(response => {
        this.availablePackages = response.data.packages;
      });
      api.request("GET", `/trips/${trip.id}/addOn`).then(response => {
        this.availableAddOns = response.data.addOns;
      });
      api.request("GET", `/trips/${trip.id}/documentCheck`).then(response => {
        this.documentChecks = response.data.documentChecks;
      });
    },
    clearPassengerFormModel() {
      this.passengerFormModel = {
        currentCustomerId: null,
        passenger: {
          packagePrice: 0,
          boardingTax: 0,
          addOns: [],
          documentChecks: this.documentChecks.map(d => {
            return {
              documentCheckId: d.id,
              documentCheckName: d.name,
              documentCheckDescription: d.description,
              documentCheckIsMandatory: d.isMandatory,
              status: 1,
              notes: null
            };
          })
        }
      };
    },
    showNewPassengerForm() {
      this.clearPassengerFormModel();
      this.isPassengerFormVisible = true;
    },
    editPassenger(passenger) {
      this.clearPassengerFormModel();
      this.passengerFormModel = {
        currentCustomerId: passenger.customerId,
        passenger: Object.assign({}, passenger)
      };
      this.isPassengerFormVisible = true;
    },
    passengerCustomerPickerChanged(customer) {
      if (!customer) return;
      this.passengerFormModel.passenger.customerName = customer.name;
    },
    passengerPackagePickerChanged(_package) {
      if (!_package) return;
      this.availablePackages.map(_ => {
        if (
          _.id == _package &&
          this.passengerFormModel.passenger.packageName != _.name
        ) {
          this.passengerFormModel.passenger.packageName = _.name;
          this.passengerFormModel.passenger.packagePrice = _.price;
        }
      });
    },
    doesPassengerHaveAddOn(addOn) {
      return (
        this.passengerFormModel.passenger.addOns.filter(
          a => a.addOnId == addOn.id
        ).length > 0
      );
    },
    removePassengerAddOn(addOn) {
      this.passengerFormModel.passenger.addOns = this.passengerFormModel.passenger.addOns.filter(
        a => a.addOnId != addOn.addOnId
      );
    },
    ensureAddOnForPassenger(addOn) {
      this.passengerFormModel.passenger.addOns = this.passengerFormModel.passenger.addOns.filter(
        a => a.addOnId != addOn.id
      );

      this.passengerFormModel.passenger.addOns.push({
        addOnId: addOn.id,
        addOnName: addOn.name,
        addOnPrice: addOn.price
      });
    },
    savePassenger() {
      var model = this.passengerFormModel.passenger;
      this.passengers = this.passengers.filter(
        p => p.customerId != this.passengerFormModel.currentCustomerId
      );

      model.contractId = this.id;
      this.passengers.push(model);

      this.isPassengerFormVisible = false;
    },
    saveContract() {
      this.$refs.operationStatusCard.show();

      var endpoint = this.id
        ? `/contracts/grouptrips/${this.id}`
        : `/contracts/grouptrips`;

      var method = this.id ? "PUT" : "POST";
      var payload = {
        contract: this.contract,
        passengers: this.passengers
      };

      api
        .request(method, endpoint, payload)
        .then(response => {
          this.$refs.operationStatusCard.succeed();
          if (!this.id) {
            this.$router.push(`/contract/${response.data.id}`);
          }
        })
        .catch(error => {
          this.$refs.operationStatusCard.fail(error.response.data);
        });
    },
    onSelectedPayments(payments) {
      this.selectedPayments = payments;
    },
    onSelectedPaymentObject(object) {
      this.selectedPaymentObject = object;
    },
    showReport(reportIndex) {
      this.reportTitle = this.reports[reportIndex].title;
      const querystring = this.reports[reportIndex].qs();
      api
        .request(
          "GET",
          this.reports[reportIndex].url + "?" + querystring,
          null,
          {},
          "arraybuffer"
        )
        .then(response => {
          this.reportUrl = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          this.reportDialog = true;
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    },
    showVoucher(passenger) {
      this.reportTitle = "Voucher";
      api
        .request(
          "GET",
          `/reports/contracts/${this.$route.params.id}/voucher/${passenger.customerId}`,
          null,
          {},
          "arraybuffer"
        )
        .then(response => {
          this.reportUrl = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          this.reportDialog = true;
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    },
    showDocumentList(passenger) {
      this.reportTitle = "Listagem de Documentos";
      api
        .request(
          "GET",
          `/reports/groupTrips/${this.contract.tripId}/documents/${passenger.customerId}`,
          null,
          {},
          "arraybuffer"
        )
        .then(response => {
          this.reportUrl = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          this.reportDialog = true;
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    },
    closeReport() {
      window.URL.revokeObjectURL(this.reportUrl);
      this.reportUrl = null;
      this.reportTitle = null;
      this.reportDialog = false;
    }
  },
  mounted() {
    if (this.id) {
      this.$refs.loadingStatusCard.show();
      api
        .request("GET", `/contracts/grouptrips/${this.id}`)
        .then(response => {
          this.contract = response.data.contract;
          if (this.contract) {
            this.totalDiscount = this.contract.totalDiscount;
            this.totalFine = this.contract.totalFine;
          }
          this.passengers = response.data.passengers;
          this.$refs.loadingStatusCard.close();
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    } else if (this.$route.params.customer_id) {
      this.$refs.loadingStatusCard.show();
      api
        .request("GET", `/customers/${this.$route.params.customer_id}`)
        .then(response => {
          var customer = response.data;

          this.contract = {
            totalDiscount: 0,
            totalFine: 0,
            responsibleUserId: this.$store.getters.userId,
            createdByUserId: this.$store.getters.userId,
            contractingPartyName: customer.name,
            contractingPartyTaxId: customer.taxId,
            contractingPartyNationalId: customer.nationalId,
            contractingPartyProfession: customer.profession,
            contractingPartyPhone: customer.phoneNumber,
            contractingPartyEmail: customer.email,
            contractingPartyAddress: `${customer.address.addressLine1}, ${customer.address.addressLine2}, ${customer.address.addressLine3}, ${customer.address.district} - ${customer.address.city} - ${customer.address.stateCode}. ${customer.address.postalCode}`
          };

          this.$refs.loadingStatusCard.close();
        })
        .catch(error => {
          this.$refs.loadingStatusCard.fail(error.response.data);
        });
    } else {
      this.contract = {
        totalDiscount: 0,
        totalFine: 0,
        responsibleUserId: this.$store.getters.userId,
        createdByUserId: this.$store.getters.userId
      };
    }
  }
};
</script>
